import styled from "styled-components";

export const TaskListBackground = styled.div`
  width: 444px;
  height: 482px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(114, 114, 114, 0.04);
  border-radius: 10px;
`;
export const TaskListTitle = styled.div`
  font-family: "Inter600";
  font-size: 24px;
  line-height: 33px;
  color: #252525;
  margin-left: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
`;
export const TaskListDescription = styled.div`
  font-family: "Inter400";
  font-size: 16px;
  line-height: 22px;
  color: #252525;
  margin-left: 16px;
`;
export const TaskListImgButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
